import { render } from "./stockProduct.vue?vue&type=template&id=7f71313c&scoped=true"
import script from "./stockProduct.vue?vue&type=script&lang=js"
export * from "./stockProduct.vue?vue&type=script&lang=js"

import "./stockProduct.vue?vue&type=style&index=0&id=7f71313c&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f71313c"]])

export default __exports__